import { Button } from "@core/button";
import { useTranslation } from "react-i18next";

const GradeSelector = ({
  selectedGrade,
  setSelectedGrade,
  minGrade = -1,
}: {
  selectedGrade: number;
  setSelectedGrade: (grade: number) => void;
  minGrade?: number;
}) => {
  const { t } = useTranslation();
  return (
    <>
      {[...Array(13)].map((_, grade) => {
        const gradeNumber = grade + 1;
        if (minGrade === -1 && gradeNumber === 13) {
          return (
            <Button
              rounded="lg"
              variant="outline"
              textColor={`${
                selectedGrade === -1 && "text-indigo-700 dark:text-indigo-200"
              }`}
              className={`p-3 col-span-full ${
                selectedGrade === -1
                  ? "border-indigo-500"
                  : "border-gray-200 dark:border-gray-600 hover:border-indigo-300 dark:hover:border-indigo-400"
              }`}
              bgColor={`${
                selectedGrade === -1 && "bg-indigo-50 dark:bg-indigo-900/50"
              }`}
              size="sm"
              key={-1}
              onClick={() => {
                setSelectedGrade(-1);
              }}
            >
              {t("courseType.UNKNOWN")}
            </Button>
          );
        }
        return gradeNumber >= minGrade && gradeNumber <= 12 ? (
          <Button
            rounded="lg"
            variant="outline"
            textColor={`${
              selectedGrade === gradeNumber &&
              "text-indigo-700 dark:text-indigo-200"
            }`}
            className={`p-3 ${
              selectedGrade === gradeNumber
                ? "border-indigo-500"
                : "border-gray-200 dark:border-gray-600 hover:border-indigo-300 dark:hover:border-indigo-400"
            }`}
            bgColor={`${
              selectedGrade === gradeNumber &&
              "bg-indigo-50 dark:bg-indigo-900/50"
            }`}
            size="sm"
            key={gradeNumber}
            onClick={() => {
              setSelectedGrade(gradeNumber);
            }}
          >
            {gradeNumber}
          </Button>
        ) : null;
      })}
    </>
  );
};

export default GradeSelector;
